__turbopack_context__.v({
  "pane": "SjfzZa_pane",
  "tabs": "SjfzZa_tabs",
});
